// Session-Heartbeat
// -----------------
//
// Wave 14bs: Admin will sehen "wann und wie lange" ein User die App nutzt.
// Der Server-Endpoint /api/me macht bei jedem Request ein last_seen_at-
// Update und rechnet die Gap zur vorherigen Request als aktive Zeit (bis
// max. 5min Gap — darüber hinaus = Pause).
//
// Dieses Modul feuert einen regelmäßigen /api/me-GET in festem Intervall
// (60s), aber NUR wenn das Tab sichtbar ist (visibilitychange). Dadurch
// sammeln wir ordentliche Usage-Zeiten auch wenn der User nur die Map
// passiv angeschaut hat.
//
// Der fetch geht absichtlich ohne Error-Handling außer leisem Logging —
// es ist rein Telemetrie, kein kritischer Pfad.

import { authFetch } from './auth';

const HEARTBEAT_MS = 60 * 1000;

let timer: number | null = null;
let active = false;

function stop() {
  if (timer !== null) {
    window.clearInterval(timer);
    timer = null;
  }
}

function start() {
  if (timer !== null) return;
  // Sofort einmal feuern, damit der first-launch-Besuch sauber geloggt wird.
  void tick();
  timer = window.setInterval(tick, HEARTBEAT_MS);
}

async function tick() {
  if (document.hidden) return;
  try {
    await authFetch('/api/me', { method: 'GET' });
  } catch {
    /* offline = egal, nächster tick versucht es neu */
  }
}

export function installHeartbeat() {
  if (active) return;
  active = true;

  const onVisibility = () => {
    if (document.hidden) stop();
    else start();
  };

  document.addEventListener('visibilitychange', onVisibility);
  if (!document.hidden) start();
}
